/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ReferenciaBancariaForm from './ReferenciaBancariaForm';
import * as validations from '../../validations/validations';
import * as referenciabancariaActions from '../../actions/referenciabancariaActions';
import * as userActions from '../../actions/userActions';

import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
 import $ from 'jquery';


class ManageReferenciaBancariaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
            tipoPagoCombo:[
                {id:1, descripcion:"Transferencia"},
                {id:2, descripcion:"PayPal"}
            
            ],
			referenciabancaria:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        
        let id=this.props.id;
        /*
        
        let pageInfo={ 
            page:'referenciabancaria', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        */
        
        usuarioActual(this, "referenciabancaria",true).then( (usuario)=>{
        
            if(id && id>0 ){

               this.props.referenciabancariaActions.getReferenciaBancaria(id, usuario).then( referenciabancaria=>{
                   this.setState({"referenciabancaria":referenciabancaria});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
            
            
            
        })
		
    }
    

    handleChange=(event, data)=> {

        let referenciabancaria = this.state.referenciabancaria;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		referenciabancaria[field[0]]= value;
		else{
             if(!referenciabancaria[field[0]]){
                    referenciabancaria[field[0]]={}
                }
			referenciabancaria[field[0]][field[1]]= value;
		}
        
		
        this.setState({"referenciabancaria": referenciabancaria});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let referenciabancaria=this.state.referenciabancaria;
              
        if(!validations.requerido(referenciabancaria.nombreBanco)){
            errors.nombreBanco=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(referenciabancaria.convenio)){
            errors.convenio=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(referenciabancaria.beneficiario)){
            errors.beneficiario=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(referenciabancaria.noCuenta)){
            errors.noCuenta=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.referenciabancariaActions.save(this.state.referenciabancaria, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <ReferenciaBancariaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.referenciabancaria}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    tipoPagoCombo={genericFormattedForDropdown(this.state.tipoPagoCombo)}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        permisos:state.permisos,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        referenciabancariaActions: bindActionCreators(referenciabancariaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
	};
}



export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageReferenciaBancariaForm));